import { collection, type Reference, subCollection, type Timestamp } from "@doitintl/models-types";

import { type UserModel } from "./User";

@collection("insights")
export class InsightModel {
  subCollections?: {
    insightsStatusChanges: InsightStatusChangeModel;
    relevantCustomersAccounts: RelevantCustomersAccountModel;
  };
}

@subCollection("insightsStatusChanges")
export class InsightStatusChangeModel {
  insightRef!: Reference<InsightModel>;

  customerId!: string;

  statusChanges!: InsightStatusChangesModel[];
}

export enum InsightUserStatus {
  ACTIONABLE = "actionable",
  ACKNOWLEDGED = "acknowledged",
  IN_PROGRESS = "in progress",
  OPTIMIZED = "optimized",
  DISMISSED = "dismissed",
}

export class InsightStatusChangesModel {
  status!: InsightUserStatus;

  timestamp!: Timestamp;

  userRef!: Reference<UserModel>;

  dismissalDetails?: DismissalDetails;
}

export class DismissalDetails {
  reasons!: string[];

  comment?: string;
}

@subCollection("relevantCustomersAccounts")
export class RelevantCustomersAccountModel {
  accounts!: Array<string>;

  lastUpdated!: string;
}
